// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbListObjectDto } from './QbListObjectDto';
import { QbAddress } from './QbAddress';
import { QbAddressBlock } from './QbAddressBlock';
import { CompanyDto } from './CompanyDto';
import { QbPaymentMethodDto } from './QbPaymentMethodDto';
import { QbTermsDto } from './QbTermsDto';
import { QbSalesRepDto } from './QbSalesRepDto';
import { QbPriceLevelDto } from './QbPriceLevelDto';
import { QbSalesTaxCodeDto } from './QbSalesTaxCodeDto';
import { QbItemSalesTaxDto } from './QbItemSalesTaxDto';
import { AuthorizeNetPaymentProfileDto } from './AuthorizeNetPaymentProfileDto';
import { LeadRatingDto } from './LeadRatingDto';
import { LeadSourceDto } from './LeadSourceDto';
import { LeadStatusDto } from './LeadStatusDto';

// AbilityIntranet.Data.Intranet.QbModels.QbCustomerDto
export class QbCustomerDto extends QbListObjectDto {
    public isLead: boolean = false;
    public parent: QbListObjectDto = null;
    public fullName: string = null;
    public companyName: string = null;
    public salutation: string = null;
    public firstName: string = null;
    public middleName: string = null;
    public lastName: string = null;
    public jobTitle: string = null;
    public billAddress: QbAddress = null;
    public billAddressBlock: QbAddressBlock = null;
    public phone: string = null;
    public altPhone: string = null;
    public email: string = null;
    public cc: string = null;
    public balance: number = null;
    public totalBalance: number = null;
    public resaleNumber: string = null;
    public accountNumber: string = null;
    public creditLimit: number = null;
    public notes: string = null;
    public company: CompanyDto = null;
    public preferredPaymentMethod: QbPaymentMethodDto = null;
    public terms: QbTermsDto = null;
    public salesRep: QbSalesRepDto = null;
    public priceLevel: QbPriceLevelDto = null;
    public salesTaxCode: QbSalesTaxCodeDto = null;
    public itemSalesTax: QbItemSalesTaxDto = null;
    public autoDebitPaymentProfile: AuthorizeNetPaymentProfileDto = null;
    public leadRating: LeadRatingDto = null;
    public leadSource: LeadSourceDto = null;
    public leadStatus: LeadStatusDto = null;
}


    



